import React from 'react';

import s from './SecondaryHeaderBar.css';
import cx from 'classnames';


const SecondaryHeaderBar = ({ className, children }) =>
  <nav className={cx(s.component, className)}>
    {children}
  </nav>;

export default SecondaryHeaderBar;


// WEBPACK FOOTER //
// ./src/components/SecondaryHeaderBar/SecondaryHeaderBar.js